import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { fetchBlogpage, fetchServices } from "../Redux/slice/homeSlice";
import { Icon } from "@iconify/react";
import { useLocation, useNavigate } from "react-router-dom";
import { API_URL } from "../Api";


const InsightRap = styled.div`
  background: linear-gradient(0deg, #ffffff 0%, #f6f5f2 20%);
  padding-bottom: 50px;
  .upper-p {
    padding: 5px 15px;
    width: fit-content;
    height: 31px;
    display: flex;
    border: 1px solid #0000001a;
    color: #1a365d;
    border-radius: 16px;
    justify-content: center;
    align-items: center;
    font-size: 11px;
    font-weight: 500;
  }
  h1 {
    color: #1a365d;
    font-size: 52px;
    line-height: 57px;
    font-weight: 400;
    max-width: 709px;
  }
  h2 {
    color: #1a365d;
    font-size: 48px;
    line-height: 57px;
    font-weight: 400;
  }
  .blog-1 {
    padding-top: 160px;
  }
  .blog-2-upper {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    gap: 20px;
  }
  .blog-2-card img {
    width: 160px;
    height: 160px;
    margin: auto;
    border-radius: 200px;
  }

  .blog-2-card-sub {
    border-top: 1px solid #0000001a;
    padding-top: 15px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .blog-2-card {
    background: #ffffff;
    border-radius: 24px;
    width: 305px;
    height: 314px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    justify-content: space-between;
  }
  .blog-2-down {
    display: flex;
    gap: 10px;
    margin-top: 50px;
    justify-content: space-between;
  }
  .blog-3-card img {
    width: 363px;
    height: 290px;
    border-radius: 16px;
  }
  .blog-3-card-sub h4 {
    color: #1a365d;
    font-weight: 500;
    font-size: 11px;
  }
  .blog-3-card-sub p {
    color: #1a365d;
    font-weight: 500;
    font-size: 22px;
    line-height: 28px;
    max-width: 347px;
  }
  .blog-3-card-sub,
  .blog-3-card-upper {
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  .blog-3-card {
    padding: 20px;
    border-radius: 24px;
    height: 541px;
    width: 400px;
    display: flex;
    background: #ffffff;
    flex-direction: column;
    justify-content: space-between;
  }
  .blog-3-card:hover {
    background: #38bdf8;
  }
  .card-10-cirle {
    background: #f6f5f2;
    width: 52px;
    height: 52px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }
  .blog-3-card:hover .card-10-cirle {
    background: #1a365d;
  }

  .card-10-circle svg {
    color: #1a365d;
  }
  .blog-3-card:hover .card-10-cirle svg {
    color: #38bdf8;
  }
  .blog-3-card-down {
    display: flex;

    justify-content: flex-end;
    align-items: flex-end;
  }
  .blog-3-down {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: space-between;
    gap: 10px;
    margin-top: 50px;
  }
  @media (max-width: 1300px) {
    .blog-3-card {
      width: 380px;
    }
    .blog-3-card img {
      width: 340px;
    }
  }
  @media (max-width: 1200px) {
    .blog-3-card {
      width: 350px;
    }
    .blog-3-card img {
      width: 310px;
    }
  }
  @media (max-width: 1100px) {
    .blog-3-card {
      width: 400px;
    }
    .blog-3-card img {
      width: 360px;
    }

    .blog-3-down {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 900px) {
    .blog-3-card {
      width: 430px;
    }
    .blog-3-card img {
      width: 380px;
    }

    .blog-3-down {
      grid-template-columns: repeat(1, 1fr);
    }
    h1 {
      font-size: 45px;
    }
  }
  @media (max-width: 700px) {
    h1 {
      font-size: 32px !important;
      line-height: 40px !important;
    }
    .blog-3-card-sub p {
      font-size: 19px !important;
    }
  }
  @media (max-width: 600px) {
    .blog-3-card {
      width: 100%;
    }
    .blog-3-card img {
      width: 100%;
    }
  }
`;

const Insights = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { blogObject } = useSelector((state) => state.content);
  console.log(blogObject);

  const insights = blogObject?.data?.lists?.data;
  useEffect(() => {
    dispatch(fetchBlogpage());
  }, [dispatch]);

  const location = useLocation();
  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    }, 0);
  }, [location.pathname]);

  const handledetails = (id) => {
    navigate(`/insights/details/${id}`);
  };
  return (
    <InsightRap>
      <div className="blog-1 containers">
        <h6 className="upper-p">{blogObject?.data?.heading?.small_title}</h6>
        <h1>
          {" "}
          {blogObject?.data?.heading?.main_title
            ?.split(" ")
            .map((word, index) => {
              const targetIndexes = [1, 2]; // 2nd word (index 1), 3rd word (index 2)
              return targetIndexes.includes(index) ? (
                <span key={index} style={{ color: "#0ea5e9" }}>
                  {word}{" "}
                </span>
              ) : (
                word + " "
              );
            })}
        </h1>
      </div>
      <div className="blog-2 containers">
        <div className="blog-3-down">
          {insights?.map((item) => (
            <div onClick={() => handledetails(item.id)} className="blog-3-card">
              <div className="blog-3-card-upper">
                <img
                  src={`${API_URL}/${item?.banner}`}
                  alt=""
                />
                <div className="blog-3-card-sub">
                  <h4>{item?.category}</h4>
                  <p>{item?.title}</p>
                </div>
              </div>
              <div className="blog-3-card-down">
                <div className=" card-10-cirle">
                  <Icon width="14px" height="14px" icon="mdi:arrow-top-right" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </InsightRap>
  );
};

export default Insights;
